export const SUPPORT_PHONE = '05421162306';
export const SUPPORT_WA_E164 = '905421162306';

export function openSupportWhatsapp(text) {
  const message = text || 'Merhaba, SolisUp ile ilgili destek almak istiyorum.';

  const encoded = encodeURIComponent(message);

  window.open(`https://wa.me/${SUPPORT_WA_E164}?text=${encoded}`, '_blank', 'noopener,noreferrer');
}
